import { Component, Input, OnChanges, OnInit } from '@angular/core';

import { CirculationType } from '../../../../Discover/Targeting/models/circulation.model';
import { CirculationFilterApiModel } from '../../../../api/targeting/model/targeting-search.api.model';
import { AbstractFilterTypeComponent } from '../../../Filter/models/abstract-filter-type.component';
import { ReachFilterModel } from '../../model/reach-filter.model';

@Component({
    selector: 'agpr-reach-filter',
    templateUrl: './reach-filter.component.html',
    styleUrls: ['./reach-filter.component.scss'],
    providers: [
        {
            provide: AbstractFilterTypeComponent,
            useExisting: ReachFilterComponent
        }
    ],
    standalone: false
})
export class ReachFilterComponent extends AbstractFilterTypeComponent implements OnInit, OnChanges {
    readonly reachMinimum = 0;
    readonly reachMaximum = 90000000;

    @Input() declare filter: ReachFilterModel;

    value: CirculationFilterApiModel = ReachFilterModel.createBlankFilter();

    ngOnInit() {
        this.value.type = CirculationType.manualValue;
    }

    ngOnChanges(): void {
        this.refresh();
    }

    refresh(): void {
        this.value = this.filter.getCurrentValue();
    }

    update(): void {
        this.value.type = this.filter.dropdownSelection.value;
        this.filter.setCurrentValue(this.value);
    }

}
